export function TextItem({ name }: { name: string }) {
  return <span className='text-[#A0ABBE] text-base'>{name}</span>
}
